var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageContentForm',{attrs:{"loading":_vm.loading,"reset-action":_vm.resetAction,"save-action":_vm.updateItemAction,"title":_vm.title,"type":"edit","item":_vm.page,"is-exhibitor":_vm.isExhibitor}})
}
var staticRenderFns = []

export { render, staticRenderFns }